// Each host declares its own global `heap`, so a global type here would clash.
type HeapClient = {
  track?: (eventName: string, properties?: Record<string, unknown>) => void;
};

/**
 * Sends a Sidekick event to the Heap SDK the host loaded. A missing SDK or
 * a throw from `track` counts as not sent, so analytics cannot fail the
 * action that triggered it.
 * @param eventName - Heap event name.
 * @param properties - Event properties.
 * @returns Whether Heap `track` completed.
 */
export const trackSidekickHeapEvent = (
  eventName: string,
  properties: Record<string, unknown>
): boolean => {
  const { heap } = globalThis as { heap?: HeapClient };
  if (typeof heap?.track !== 'function') {
    return false;
  }

  try {
    heap.track(eventName, properties);
  } catch {
    return false;
  }

  return true;
};
